// The confirm step every CSV upload passes through (spec 2026-09-24-three-streams):
// ClearPath guesses, the owner confirms, and only then is anything written.
export type UploadKind = 'sales' | 'payments' | 'bills';

export const KIND_OPTIONS: { kind: UploadKind; label: string; hint: string }[] = [
  { kind: 'sales', label: 'Sales from my register', hint: 'Each item sold — Square, Clover, Toast, Shopify' },
  { kind: 'payments', label: 'Payments I received', hint: 'Invoices you sent that customers paid — Stripe, QuickBooks' },
  { kind: 'bills', label: 'Bills I paid', hint: 'What you paid suppliers and vendors' },
];

const LOOKS_LIKE: Record<UploadKind, string> = {
  sales: 'sales from your register', payments: 'payments you received', bills: 'bills you paid',
};

export function guessSentence(rows: number, fileName: string, guess: UploadKind): string {
  return `We read ${rows} rows from ${fileName}. It looks like ${LOOKS_LIKE[guess]}.`;
}

export function importedLine(kind: UploadKind, records: number): string {
  if (kind === 'payments') return `Imported ${records} payments — see Payments`;
  if (kind === 'bills') return `Imported ${records} bills — see Costs`;
  return `Imported ${records} sales`;
}

export interface InspectResult {
  rows: number;
  date_range: [string | null, string | null];
  guess: UploadKind;
  reasons: string[];
}
